import React, { Suspense } from "react";
import Loader from "components/loader";
import { Routes, Route } from "react-router-dom";
import Home from "pages/home";
import Error404 from "pages/error-404";
/* PLOP_IMPORT_ROUTES */
import Reassessments from "pages/reassessments";
import CorrectionsApprovalBatchDetails from "pages/corrections-approval-batch-details";
import CorrectionsApprovals from "pages/corrections-approvals";
import Corrections from "pages/corrections";
import Notifications from "pages/notifications";
import ApprovalBatchDetails from "pages/approval-batch-details";
import References from "pages/references";
import Approvals from "pages/approvals";
import AmbiguousExceptions from "pages/ambiguous-exceptions";
import ApttusExceptions from "pages/apttus-exceptions";
import { RouteGuard } from "./RouteGuard";

const Router: React.FC = (): JSX.Element => {
  // TODO: Remove this flag when launching for production
  const isDevOrBetaEnvironment =
    process.env.NODE_ENV === "development" ||
    (typeof window !== "undefined" &&
      window.location &&
      window.location.hostname &&
      window.location.hostname.includes("beta")) ||
    process.env.REACT_APP_STAGE === "beta";

  return (
    <Suspense fallback={<Loader loadingText="Loading..." />}>
      <Routes>
        <Route path="" element={<RouteGuard />}>
          <Route path="" element={<Home />} />
          <Route path="apttus-exceptions" element={<ApttusExceptions />} />
          <Route
            path="ambiguous-exceptions"
            element={<AmbiguousExceptions />}
          />
          <Route path="approvals">
            <Route path="" element={<Approvals />} />
            <Route path="corrections">
              <Route path="" element={<CorrectionsApprovals />} />
              <Route
                path=":batchId"
                element={<CorrectionsApprovalBatchDetails />}
              />
            </Route>
            <Route path=":batchId" element={<ApprovalBatchDetails />} />
          </Route>
          <Route path="references" element={<References />} />
        </Route>
        {/* PLOP_INJECT_ROUTES */}
        {isDevOrBetaEnvironment && (
          <>
            <Route path="/reassessments" element={<Reassessments />} />
          </>
        )}
        <Route path="/corrections" element={<Corrections />} />
        <Route path="/notifications" element={<Notifications />} />

        {/* Must be the last route */}
        <Route path="*" element={<Error404 />} />
      </Routes>
    </Suspense>
  );
};

export default Router;
